<template>
  <div>
    <div v-if="!loading">
      <table class="
            pt-2
            table table-sm table-responsive
            border-bottom
            max-w-full
            divide-y divide-gray-200
            rounded
            col-sm-12
          ">
        <thead class="table-active">
          <tr>
            <th scope="col" class="
                  px-6
                  text-left text-xs
                  font-medium
                  text-gray-500
                  align-middle
                  mx-2
                  col-sm-1
                ">
              Estado
            </th>
            <th scope="col" class="
                  px-6
                  text-left text-xs
                  font-medium
                  text-gray-500
                  align-middle
                  mx-2
                  col-sm-11
                ">
              Notificación
            </th>
            <th scope="col" class="
                  px-6
                  text-left text-xs
                  font-medium
                  text-gray-500
                  align-middle
                  mx-2
                  col-sm-2
                ">
              Fecha
            </th>
          </tr>
        </thead>
        <tbody class="bg-white divide-y divide-gray-200">
          <tr v-for="item in notifications" :key="item.id"
            :style="`${item.viewed === 1 || item.viewed === true ? 'cursor:pointer;' : null}`"
            v-on:click="(item.viewed === 1 || item.viewed === true) && update(item.id, false, item.companies_id, item.message_id, item.user_sst_id)"
            :class="`${item.viewed === 1 || item.viewed === true ? 'bg-soft-primary' : null} `">
            <td
              :class="`px-6 text-sm text-gray-500 text-center align-middle mx-2 ${item.viewed === 1 || item.viewed === true ? 'text-black' : 'text-muted'}`">
              <i class="mdi mdi-message-text mr-2 mdi-24px"></i>
            </td>
            <td
              :class="`px-6 text-sm text-gray-500 mx-2 ${item.viewed === 1 || item.viewed === true ? 'text-black' : 'text-muted'}`">
              <b v-if="item.viewed === 1 || item.viewed === true">
                {{ replaceCompany(item.message.message) }}
              </b>
              <span v-else>
                {{ replaceCompany(item.message.message) }}
              </span>
            </td>
            <td
              :class="`px-6 text-sm text-gray-500 mx-2 ${item.viewed === 1 || item.viewed === true ? 'text-black' : 'text-muted'}`">
              {{ dateConvert(item.created_at) }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div v-else>
      <div class="text-center">
        <b-spinner variant="primary" label="Loading..."></b-spinner>
      </div>
    </div>
    <Pagination @loading="(load) => (loading = load)" ref="paginator" :search="search"
      @fetch="(items) => (notifications = items)" />
  </div>
</template>

<script>
import Pagination from "./NotificationPagination"
import NotificationAPI from '@/services/notifications/notificationsAPI';
import { dateFormat } from "@/utils/helpers/format"

export default {
  components: { Pagination },
  props: {
    companyID: {
      type: Number,
      required: true
    },
  },
  data() {
    return {
      notifications: [],
      search: null,
      loading: true,

      classificationID: this.$store.getters["company/getCompany"].company_classification_id || null,
      company: this.$store.getters["company/getCompany"] || null,

      user: this.$store.state.auth || null,
    };
  },
  methods: {
    fetch() {
      this.$refs.paginator.query();
    },

    /**
     * This method is used to knows if the user has the permission indicated
     * @param {String} name The name of the permission
     * @param {Array} roles the roles that permitted to access the action 
     * @returns {Boolean} true if the user has the permission indicated or false if no
     */
    getRole(name, roles) {

      // Get the user role
      let role = this.$store.state.auth.info.role ? this.$store.state.auth.info.role : null

      // If the user is logged
      if (role) {

        // If the roles array is not empty
        if (roles) {

          // Know if the role indicated is in the roles array
          role = roles.includes(role) ? true : false

        } // Close if the roles arrays is not empty

        // If the roles arrays is empty
        else {

          // Know if the user role is in the roles indicated
          role = role === 1

        } // Close if the roles arrays is empty

        // Get the user permissions
        const permissions = this.$store.state.auth.info.permissions

        // Know if the user has the permission indicated
        const enabled = permissions.find(permission => permission.name === name)

        // If the user has the permission indicated and the user role is in the roles indicated
        return enabled && role ? true : false

      } // Close if the user is logged

      // If the user is not logged
      else {
        return false
      } // Close else the user is not logged
    },

    /**
         * This method is used to convert the date to a format that is easier to read.
         * @param {string} date - The date to be converted.
         */
    dateConvert(date) {
      if (date) {
        return dateFormat(date)
      } else {
        return '-'
      }
    },

    update(id, viewed, companyID, messageID, userID) {

      const data = {
        viewed: viewed,
        companies_id: companyID,
        message_id: messageID,
        user_sst_id: userID
      }

      NotificationAPI.update(id, data)
        .then(response => {
          console.log(response)
          if (response.message === 'Notification editado con exito') {
            this.changeStatus(id)
          }
        });
    },

    changeStatus(id) {
      this.notifications = this.notifications.map(item => {
        if (item.id === id) {
          item.viewed = 0
        }
        return item
      })
    },

    replaceCompany(message) {
      let text = ''

      text = message.replace('Nombreempresa', this.company.social_reason)
      text = text.replace('xxx', this.company.social_reason)
      text = text.replace(':nombreEmpresa', this.company.social_reason)

      return text

    }
  },
};
</script>
